export enum StrategyGroupTypes {
    SingleSymbol = 0,
    MultiSymbol = 1,
}
